import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import style from './style.module.less'
import Img from '@UI/Img'
import { Flex } from 'hljd'
import { MEAL_TAG_IMG } from '@constant'
import { CollectorsCount, Price } from '../../Common/Goods'
import { getPropertyId } from '@util'

/**
 * TODO，这里没有数据情况下的占位元素样式逻辑需优化
 */
@inject('decorationStore')
@observer
export default class extends Component {
  getImgStyle = () => {
    return {
      width: getPropertyId() == 14 ? 114 : 170,
      height: 114
    }
  }

  render() {
    const {
      cover_path,
      title,
      actual_price,
      hot_tag,
      mode,
      coupon_info,
      isTeamMeal,
      decorationStore: { newThemeConfig }
    } = this.props
    const isFake = mode === 'fake'
    const fakeStyle = {
      backgroundColor: '#eee',
      width: '100%',
      height: 18,
      marginBottom: 3
    }
    const fakeBottomStyle = {
      backgroundColor: '#eee',
      width: '50%',
      height: 18
    }
    const imgStyle = this.getImgStyle()

    return (
      <Flex className={style.item}>
        <div className={style.photo} style={imgStyle}>
          {isFake ? (
            <div
              style={{
                backgroundColor: '#eee',
                width: '100%',
                height: '100%',
                borderRadius: 12
              }}
            />
          ) : (
            <Img className={style.img} src={cover_path} style={imgStyle} />
          )}

          <img className={style.hotTag} src={MEAL_TAG_IMG[hot_tag + '']} />
        </div>

        <Flex d="v" sp className={style.info}>
          {isFake ? (
            <div>
              <div style={fakeStyle} />
              <div style={fakeStyle} />
            </div>
          ) : (
            <div className={style.title}>{title}</div>
          )}

          {coupon_info &&
            !isTeamMeal && (
              <div
                style={{
                  color: newThemeConfig['themeColor'],
                  border: `1px solid ${newThemeConfig['themeColor']}`,
                  alignSelf: 'flex-start',
                  padding: '0 3px'
                }}
              >
                {coupon_info}
              </div>
            )}

          {isFake ? (
            <div style={fakeBottomStyle} />
          ) : (
            <Flex className={style.content} d="v">
              <Flex vc wrap>
                <Price {...this.props} show_price={actual_price} />
              </Flex>

              <CollectorsCount {...this.props} style={{ marginTop: 10 }} />
            </Flex>
          )}
        </Flex>
      </Flex>
    )
  }
}
